import { lazy } from 'solid-js'
import { messages } from '../../pages/savings-page/savings-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/savings-page/savings-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/savings',
    titleMessage: messages.titleMessage,
}
